import { ColumnDefinition } from '~/types/ReactTableTypes';

import BaseColumnDefinitions from '../baseColumnDefinitions';
import InternationalColumns from '../internationalColumns';

const MIN_WIDTH = 40;

const addMinWidthToColumn = (column: ColumnDefinition): ColumnDefinition => ({
    ...column,
    minWidth: MIN_WIDTH,
});

const addMinWidthToColumns = (columns: Array<ColumnDefinition>): Array<ColumnDefinition> =>
    columns.map(addMinWidthToColumn);

const CAREER_COLS = [
    BaseColumnDefinitions.INDEX_COL,
    InternationalColumns.PLAYER_NAME,
    InternationalColumns.TEAM_NAMES,
];

const TOURNAMENT_COLS = [
    BaseColumnDefinitions.INDEX_COL,
    {
        ...InternationalColumns.PLAYER_NAME,
        maxWidth: 200,
    },
    {
        ...InternationalColumns.TEAM_NAME,
        maxWidth: 150,
    },
    InternationalColumns.TOURNAMENT_NAME,
];

const GAME_COLS = [...TOURNAMENT_COLS, InternationalColumns.SERIES_TITLE, InternationalColumns.GAME_INFO];

const PERIOD_COLS = [...GAME_COLS, InternationalColumns.PERIOD_COL];

const GAME_STATS_COLS = [
    BaseColumnDefinitions.GAMES_PLAYED_COL,
    BaseColumnDefinitions.GAMES_STARTED_COL,
    BaseColumnDefinitions.WINS_COL,
    BaseColumnDefinitions.LOSSES_COL,
    BaseColumnDefinitions.TIES_COL,
    BaseColumnDefinitions.OVERTIME_LOSSES_COL,
];

const SHOTS_SAVES_GA_COL = [
    BaseColumnDefinitions.SHOTS_AGAINST_COL,
    InternationalColumns.SAVES,
    BaseColumnDefinitions.GOALS_AGAINST_COL,
];

const SMALL_GOALIE_STATS = [...addMinWidthToColumns(GAME_STATS_COLS), ...addMinWidthToColumns(SHOTS_SAVES_GA_COL)];

export const goaltenderInternationalColumns = {
    'international-goaltender-most-championships-career': [
        ...CAREER_COLS,
        InternationalColumns.CHAMPIONSHIPS,
        InternationalColumns.YEARS_WON,
    ],
    'international-goaltender-most-tournaments-played-career': [
        ...CAREER_COLS,
        InternationalColumns.TOURNAMENTS_PLAYED,
        ...GAME_STATS_COLS,
        InternationalColumns.CHAMPIONSHIPS,
    ],
    'international-goaltender-most-games-played-career': [
        ...CAREER_COLS,
        InternationalColumns.TOURNAMENTS_PLAYED,
        ...GAME_STATS_COLS,
        InternationalColumns.CHAMPIONSHIPS,
    ],
    'international-goaltender-most-wins-career': [
        ...CAREER_COLS,
        ...GAME_STATS_COLS,
        BaseColumnDefinitions.WIN_PCTG_COL,
    ],
    'international-goaltender-lowest-goals-against-average-career': [
        ...CAREER_COLS,
        ...SMALL_GOALIE_STATS,
        {
            ...BaseColumnDefinitions.TIME_ON_ICE_COL,
            accessor: 'totalSecondsOnIce',
            minWidth: MIN_WIDTH,
        },
        addMinWidthToColumn(InternationalColumns.GOALS_AGAINST_AVERAGE_COL),
    ],
    'international-goaltender-lowest-goals-against-average-tournament': [
        ...TOURNAMENT_COLS,
        ...SMALL_GOALIE_STATS,
        {
            ...BaseColumnDefinitions.TIME_ON_ICE_COL,
            accessor: 'totalSecondsOnIce',
            minWidth: MIN_WIDTH,
        },
        addMinWidthToColumn(InternationalColumns.GOALS_AGAINST_AVERAGE_COL),
    ],
    'international-goaltender-highest-save-percentage-career': [
        ...CAREER_COLS,
        ...SMALL_GOALIE_STATS,
        addMinWidthToColumn(InternationalColumns.SAVE_PCTG_COL),
    ],
    'international-goaltender-highest-save-percentage-tournament': [
        ...TOURNAMENT_COLS,
        ...SMALL_GOALIE_STATS,
        addMinWidthToColumn(InternationalColumns.SAVE_PCTG_COL),
    ],
    'international-goaltender-most-saves-career': [
        ...CAREER_COLS,
        ...SMALL_GOALIE_STATS,
        addMinWidthToColumn(InternationalColumns.SAVE_PCTG_COL),
    ],
    'international-goaltender-most-saves-tournament': [
        ...TOURNAMENT_COLS,
        ...SMALL_GOALIE_STATS,
        addMinWidthToColumn(InternationalColumns.SAVE_PCTG_COL),
    ],
    'international-goaltender-most-saves-game': [...GAME_COLS, ...SHOTS_SAVES_GA_COL],
    'international-goaltender-most-saves-period': [...PERIOD_COLS, ...SHOTS_SAVES_GA_COL],
    'international-goaltender-most-shots-against-career': [
        ...CAREER_COLS,
        ...SMALL_GOALIE_STATS,
        addMinWidthToColumn(InternationalColumns.SAVE_PCTG_COL),
    ],
    'international-goaltender-most-shots-against-tournament': [
        ...TOURNAMENT_COLS,
        ...SMALL_GOALIE_STATS,
        addMinWidthToColumn(InternationalColumns.SAVE_PCTG_COL),
    ],
    'international-goaltender-most-shots-against-game': [...GAME_COLS, ...SHOTS_SAVES_GA_COL],
    'international-goaltender-most-shots-against-period': [...PERIOD_COLS, ...SHOTS_SAVES_GA_COL],
    'international-goaltender-all-time-shutouts': [
        InternationalColumns.PLAYER_NAME,
        InternationalColumns.TEAM_NAME,
        InternationalColumns.TOURNAMENT_NAME,
        InternationalColumns.SERIES_TITLE,
        InternationalColumns.GAME_INFO,
        InternationalColumns.SAVES,
    ],
};
